module.exports = __webpack_public_path__ + "img/android_installation_screenshot.10e3a1eb.png";